const Chaat = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Chaat-1.jpg"
				alt="Chaat"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Chaat-2.jpg"
				alt="Chaat"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Chaat-3.jpg"
				alt="Chaat"
			/>
		</div>
	);
};

export default Chaat;
